import React from 'react';

export const DropdownIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.75 0.750002L4.59 4.75L8.43 0.750001"
        stroke="#2B2A29"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
